import React, { useState, useEffect } from "react";
import classes from "./cancelModal.module.css";

const CancelModal = ({ closeModal, isModalOpen, handleOnCancelClick }) => {
  const [isClosing, setIsClosing] = useState(false);

  // Handle the component mounting and unmounting with animations
  useEffect(() => {
    if (!isModalOpen) {
      setIsClosing(false);
    }
  }, [isModalOpen]);

  // Handle the close with animation
  const handleClose = () => {
    setIsClosing(true);
    closeModal();
  };

  // Handle the cancel booking with animation
  const handleCancel = () => {
    handleOnCancelClick();
    closeModal();
  };

  if (!isModalOpen) return null;

  return (
    <div
      className={`${classes.modalOverlay} ${
        isClosing ? classes.modalOverlayClosing : ""
      }`}
    >
      <div
        className={`${classes.modalContainer} ${
          isClosing ? classes.modalContainerClosing : ""
        }`}
      >
        <div className={classes.modalHeader}>
          <h3>Cancel Booking</h3>
          <button onClick={handleClose} className={classes.closeButton}>
            ×
          </button>
        </div>
        <div className={classes.modalBody}>
          <p>Are you sure you want to cancel your booking?</p>
        </div>
        <div className={classes.modalFooter}>
          <button onClick={handleClose} className={classes.btnCancel}>
            Close
          </button>
          <button onClick={handleCancel} className={classes.btnConfirm}>
            Cancel Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;
